<template>
    <div>
    <vx-card
        v-if="requestsClub.length > 0"
        :title="$t('requests_join')"
        class="mt-6 lg:mt-base"
    >
        <!-- FRIENDS LIST -->
        <ul class="friend-suggesions-list">
            <li
                class="friend-suggestion flex items-center mb-4 justify-between"
                v-for="(friend, index) in requestsClub"
                :key="index"
            >
                <profile
                    :avatar="friend.student_profile.avatar"
                    :subtitle="friend.membership_role.name"
                    :profile="friend.student_profile"
                />
                <div class="flex">
                    <div class="ml-2 cursor-pointer">
                        <vx-tooltip
                            :text="$t('accept_student')"
                            position="right"
                        >
                            <vs-button
                                @click="approveJoin(friend)"
                                radius
                                size="small"
                                type="border"
                                icon-pack="feather"
                                icon="icon-user-plus"
                            />
                        </vx-tooltip>
                    </div>

                    <div class="ml-2 cursor-pointer">
                        <vx-tooltip
                            :text="$t('delete_student')"
                            position="bottom"
                        >
                            <vs-button
                                @click="deleteJoin(friend)"
                                radius
                                size="small"
                                type="border"
                                icon-pack="feather"
                                icon="icon-minus"
                            />
                        </vx-tooltip>
                    </div>
                </div>
            </li>
        </ul>
    </vx-card>
    </div>
</template>


<script>
import Profile from "@/widgets/Profile";

export default {
    components:{Profile},

    data() {
        return {
            requestsClub: [],
        }
    },

    props:{
        isFounder:{
            type:Boolean,
            default:false,
        }
    },
    computed: {
        uid() {
            return this.$route.query.uid;
        },

    },
    watch:{
        isFounder(){
            if(this.isFounder)
                this.getRequestStudents();
        }
    },

    methods:{
          // Получение всех заявок на вступление
        async getRequestStudents() {
            const res = await this.$http(
                `student_clubs/my_student_clubs/${ this.uid }/get_requests_join_club/`
            );
            this.requestsClub = res.data.results;
        },

        // Одобрение вступления в клуб
        async approveJoin(student) {
            this.$vs.loading();
            const res = await this.$http.post(
                `/student_clubs/my_student_clubs/${ this.uid }/approve_club_members/`,
                { uid: student.uid }
            );
            if (res.status === 200) {
                this.requestsClub = this.requestsClub.filter(
                    (item) => item.uid !== student.uid
                );
                //обновляет блок Участники 
                this.$store.commit('studclubs/changeFriendSuggestion',true);

                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("request_accept"),
                    color: "primary",
                });
            }
            this.$vs.loading.close();
        },
        // Отклонить заявку
        async deleteJoin(student) {
            this.$vs.loading();
            const res = await this.$http.delete(
                `/student_clubs/my_student_clubs/${ this.uid }/delete_join_club_request/`,
                { data: { request_uid: student.uid } }
            );
            if (res.status === 200) {
                this.requestsClub = this.requestsClub.filter(
                    (item) => item.uid !== student.uid
                );

                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("request_deleted"),
                    color: "primary",
                });
            }
            this.$vs.loading.close();
        },
    }
}
</script>